import { Layout } from 'antd';
import './GeneralFooter.less';
const { Footer } = Layout;

const GeneralFooter = () => {
    return (
        <Footer className="site-layout-footer">©2024 . (1395512-U). All rights reserved. Powered by AcerPay</Footer>
    )
}

export default GeneralFooter;